import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import { RefreshIcon, BackArrow } from '../../../img/Reports/ReportsSvgImages';
import useReportList from '../hooks/useReportList';

const ReportHeader = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isDataFetching, refreshHandler } = useReportList();

  return (
    <>
      <div className="header-container">
        <div className="d-flex align-items-center">
          <span>
            <Link
              to={{
                pathname: '/admin/admin-dashboard',
              }}
              className="back-link-arrow"
            >
              <BackArrow className="back-link-arrow" />
            </Link>
          </span>
          <h1 className="reports-header">{t('admin.pages.reports.module')}</h1>
        </div>
        <div className="d-flex align-items-center flex-wrap">
          <div
            className={`${
              isDataFetching
                ? 'disabled-refresh-container'
                : 'refresh-container'
            }`}
            onClick={() => !isDataFetching && refreshHandler()}
          >
            <div className="icon-container">
              <RefreshIcon className={isDataFetching && 'rotate'} />
            </div>
            <div className="refresh-text">
              {t('admin.pages.reports.refresh_text')}
            </div>
          </div>
          <div>
            <GenericButton
              variant="primary"
              tabIndex={0}
              ariaLabel="Click to go to generate document screen"
              onClick={() => navigate('/admin/generate-report')}
            >
              {t('admin.pages.reports.generate_report_button_text')}
            </GenericButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportHeader;
